import React, { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Body } from '@swyftx/aviary/atoms/Typography';
import { NumericProps } from '@swyftx/aviary/atoms/Typography/Numeric/Numeric.styles';
import { EnhancedTooltip } from '@swyftx/aviary/molecules/EnhancedTooltip/EnhancedTooltip';

import { cn } from '@shared/utils/lib/ui';

import { useSwyftxMargin } from 'src/lib/margin';

type Props = {
  title: string;
  tooltip?: string;
  name?: string;
  size?: NumericProps['size'];
  className?: string;
};

const MarginAccountCustomItem: React.FC<PropsWithChildren<Props>> = ({ title, tooltip, name, children, className }) => {
  const { isUnderMaintenance } = useSwyftxMargin();
  const { t } = useTranslation('margin');

  return (
    <FlexLayout
      direction='column'
      justifyContent='space-between'
      className={cn('h-full gap-[6px] whitespace-nowrap', className)}
    >
      <EnhancedTooltip title={tooltip} name={name || title} align='start' side='top'>
        <span>
          <Body size='xsmall' color='secondary' underline='dashed'>
            {title}
          </Body>
        </span>
      </EnhancedTooltip>

      {isUnderMaintenance ? (
        <Body color='primary'>{t('maintenance.labels.unavailable')}</Body>
      ) : (
        <span>{children}</span>
      )}
    </FlexLayout>
  );
};

export { MarginAccountCustomItem };
